<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReservationIndex'
}
</script>
